import React from 'react';
import DataTable from './DataTable/Table';
import { useState,useEffect } from 'react';
import userService from '../../app/services/user.service';

const VideoSolutionList = () => {
  const [loading ,setLoading]=useState(false);
  const [searchvalue,setSearchvalue]=useState("");

  const [data,setData]=useState([{
    S_No:12,
    QID:45,
    q_text:"this is physics question",
    link:"motion.com",
    video_cript_link:"motion"
}])

useEffect(() => {
  setLoading(true); // Set loading to true when fetching starts
  
  const payload = {
    searchvalue: searchvalue
  };
  
  userService.getVideoSolutionData(payload)
    .then(res => {
      setData(res.data.question_data);
      console.log(res.data.question_data);
      setLoading(false); // Set loading to false when data is received
    })
    .catch(err => {
      console.log(err);
      setLoading(false); // Set loading to false even if there's an error
    });
}, [searchvalue]);
  const headers = [
    { name: "S.No.", field: "id", sortable: true },
    { name: "QID", field: "qid", sortable: true },
    { name: "Q_Text", field: "q_text", sortable: true },
    { name: "Link", field: "link", sortable: false },
    { name: "Video Cript Link", field: "video_cript_id", sortable: true },
    { name: "Action", field: "Action", sortable: true },
    
  ];
  
  return (
    <div>
       <DataTable
      noDataShow={true}
      headerdata={headers}
      data={data}
      type={"solution_list"}
     
      setSearchvalue={setSearchvalue}
      />
    </div>
  )
}

export default VideoSolutionList
